const CateringPackageReviewStep = ({
  form,
  reviewData,
  getCustomerLabel,
  packages,
  calculatePackageTotal,
}) => {
  return (
    <div>
      <div className="mb-6 p-4 bg-gray-50 rounded-lg">
        <div className="flex items-center gap-2 mb-2">
          <span className="text-sm text-gray-600">Customer</span>
          <span className="text-red-500">*</span>
        </div>
        <div className="text-base font-medium">{getCustomerLabel()}</div>
      </div>

      <h3 className="text-base font-medium mb-4">Products to Purchase</h3>

      <div className="bg-gray-50 rounded-lg overflow-hidden">
        <div className="grid grid-cols-12 gap-4 p-3 bg-gray-100 text-xs font-medium">
          <div className="col-span-5">PRODUCT</div>
          <div className="col-span-3 text-center">QUANTITY</div>
          <div className="col-span-4 text-center">SUBTOTAL</div>
        </div>

        {packages.map((pkg) => (
          <div
            key={pkg.id}
            className="grid grid-cols-12 gap-4 p-3 border-b items-center"
          >
            <div className="col-span-5 flex items-center gap-2">
              <div className="w-12 h-12 bg-orange-100 rounded flex items-center justify-center">
                <img src={pkg.packageImageUrl} alt={pkg.packageName} />
              </div>
              <span className="text-sm">{pkg.packageName}</span>
            </div>
            <div className="col-span-3 text-center text-sm">
              {pkg.totalPeople} servings
            </div>
            <div className="col-span-4 text-center text-sm font-medium">
              ₦{calculatePackageTotal(pkg).toLocaleString()}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 bg-orange-50 p-4 rounded-lg">
        <div className="flex justify-between mb-2">
          <span className="text-sm">Subtotal:</span>
          <span className="text-sm font-medium">
            ₦{reviewData?.subtotal.toLocaleString()}
          </span>
        </div>
        <div className="flex justify-between mb-3">
          <span className="text-sm">Discount:</span>
          <span className="text-sm font-medium">
            {reviewData?.discountText}
          </span>
        </div>
        {/* <div className="flex justify-between mb-3">
          <span className="text-sm">Service Fee:</span>
          <span className="text-sm font-medium">
            {reviewData?.serviceFeeText}
          </span>
        </div> */}
        <div className="flex justify-between pt-3 border-t border-orange-200">
          <span className="font-medium">Total Amount:</span>
          <span className="text-lg font-bold">
            ₦{reviewData?.total.toLocaleString()}
          </span>
        </div>
      </div>
    </div>
  );
};
export default CateringPackageReviewStep;
